/**
 * Centralized API endpoint definitions
 */

export const ENDPOINTS = {
  // Listings
  LISTINGS: '/api/listings',
  LISTING_DETAIL: (id: string) => `/api/listings/${id}`,

  // Lookups
  DISTRICTS: '/api/districts',
  CITIES: '/api/cities',
  PROPERTY_TYPES: '/api/property-types',

  // Future endpoints (placeholder)
  // AUTH: {
  //   LOGIN: '/api/auth/login',
  //   LOGOUT: '/api/auth/logout',
  //   REFRESH: '/api/auth/refresh',
  // },
  // USERS: {
  //   ME: '/api/users/me',
  //   PROFILE: '/api/users/profile',
  // },
  // PURCHASES: {
  //   CREATE: '/api/purchases',
  //   DETAIL: (id: string) => `/api/purchases/${id}`,
  // },
} as const;
